/****   http.js   ****/
// 导入封装好的axios实例
import requset from "@/api";

const http = {
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url, params) {
        const config = {
            method: 'get',
            url: url
        }
        if (params) config.params = params
        return requset(config)
    },
    post(url, params, formData) {
        const config = {
            method: 'post',
            url: url
        }
        if (formData) config.headers = { 'content-type': 'multipart/form-data' };

        if (params) config.data = params
        return requset(config)
    },
    put(url, params) {
        const config = {
            method: 'put',
            url: url
        }
        if (params) config.params = params
        return requset(config)
    },
    delete(url, params) {
        const config = {
            method: 'delete',
            url: url
        }
        if (params) config.params = params
        return requset(config)
    }
}
//导出
export default http

